// src/features/my-shift/shiftColors.ts
export interface ShiftColor {
  bg: string;
  text: string;
  border: string;
}

const FALLBACK: ShiftColor = { bg: "#F3F4F6", text: "#6b7280", border: "#9CA3AF" };

// 后端不提供颜色，前端维护 code → 配色。未知 code 兜底为灰。
const MAP: Record<string, ShiftColor> = {
  morning: { bg: "#FEF3C7", text: "#92400e", border: "#F59E0B" },
  afternoon: { bg: "#FFEDD5", text: "#9a3412", border: "#F97316" },
  evening: { bg: "#DBEAFE", text: "#075985", border: "#0EA5E9" },
  night: { bg: "#EDE9FE", text: "#5b21b6", border: "#7C3AED" },
  off: { bg: "#F3F4F6", text: "#6b7280", border: "#9CA3AF" },
};

export function shiftColor(code: string | undefined | null): ShiftColor {
  if (!code) return FALLBACK;
  return MAP[code] ?? FALLBACK;
}
